import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1308463113999879';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
type MetaWindow = Window & {
  fbq?: MetaPixelFunction;
  _fbq?: MetaPixelFunction;
  __metaPixelInitialized?: boolean;
};
function loadMetaPixel() {
  const metaWindow = window as MetaWindow;

  // Guard: only ever init + track PageView once per page load,
  // even across React StrictMode double-mounts or remounts.
  if (metaWindow.__metaPixelInitialized) return;
  metaWindow.__metaPixelInitialized = true;
  if (!metaWindow.fbq) {
    const pixel = function (...args: unknown[]) {
      if (pixel.callMethod) {
        pixel.callMethod(...args);
        return;
      }
      pixel.queue.push(args);
    } as MetaPixelFunction;
    pixel.queue = [];
    pixel.push = (...args: unknown[]) => pixel.queue.push(args);
    pixel.loaded = true;
    pixel.version = '2.0';
    metaWindow.fbq = pixel;
    metaWindow._fbq = pixel;
  }
  if (!document.querySelector('script[data-meta-pixel="true"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.dataset.metaPixel = 'true';
    document.head.appendChild(script);
  }
  metaWindow.fbq?.('init', META_PIXEL_ID);
  metaWindow.fbq?.('track', 'PageView');
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" data-mp="38m1gy6n8bjph" />;
}